const transitionDurationMs = 275;
const details = "_35sd15qsrn2";
const content = "_35scs7yob3";

export { content, details, transitionDurationMs };
import "./_task-accordion.style.linaria.module.css";
//# sourceMappingURL=_task-accordion.style.js.map
